import '../../css/base.css';
import list from '../../img/icon/list.svg';
import $ from 'jquery';

const Header = () => {

  const menuToggle = () => {
    if ($(".menu-container").css("display")  === "block") {
      var menu = document.getElementById("main-menu");
      menu.style.display = "none";
    } else {
      var menu = document.getElementById("main-menu");
      menu.style.display = "block";
    }

  }

  return (
    <div className="heading-primary">
      <button className="collapse-button" type="button" onClick={menuToggle}>
        <span className="collapse-icon">
          <img src={list} alt="List" width="40" height="40" />
        </span>
      </button>
      <h1>
          <span className="heading-primary-main">Shore Cottage Arnisdale</span>
          <span className="heading-primary-sub">Scottish Highlands</span>
      </h1>
    </div>
  );
}

export default Header;